<script setup lang="ts">
  import { useTheme as use_theme } from 'vuetify'
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import default_layout from '@/layouts/default.vue'
  import authorize_layout from '@/layouts/authorize.vue'
  import error_layout from '@/layouts/error.vue'
  import { auth_ready, auth_initialized } from '@/stores/user'

  const theme = use_theme()
  const set_theme = (dark: MediaQueryList | MediaQueryListEvent) => {
    if (dark.matches) theme.global.name.value = 'dark'
    else theme.global.name.value = 'light'
  }
  const dark_mode = window.matchMedia('(prefers-color-scheme: dark)')
  set_theme(dark_mode)
  dark_mode.addEventListener('change', is_dark => {
    set_theme(is_dark)
  })

  // Wait for auth to initialize
  auth_initialized

  const route = useRoute()

  const layout = computed(() => {
    const layouts = {
      default: default_layout,
      authorize: authorize_layout,
      error: error_layout
    }

    return layouts[(route.meta.layout as string) || 'default'] || default_layout
  })
</script>

<template>
  <v-app>
    <template v-if="auth_ready">
      <component :is="layout">
        <router-view />
      </component>
    </template>
    <v-container v-else class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-progress-circular indeterminate />
      </v-row>
    </v-container>
  </v-app>
</template>
